// Single place where markdown becomes HTML.
//
// Everything rendered here is untrusted: LLM output derives from uploaded
// documents (which may contain HTML), and branding texts are admin-editable
// but reach anonymous embed visitors. marked passes raw inline HTML through,
// so the result MUST be sanitized before it touches innerHTML.
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ breaks: true, gfm: true });

// Formatting only — no scripts, no event handlers, no embedded objects.
const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'del', 'code', 'pre', 'blockquote',
  'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'a', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'hr', 'span',
];
const ALLOWED_ATTR = ['href', 'title', 'target', 'rel'];

// Links leave the app (and the iframe): force safe target/rel on every anchor.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/** Render untrusted markdown to sanitized HTML. */
export function renderMarkdown(text) {
  return DOMPurify.sanitize(marked.parse(text || ''), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Block javascript:/data: URLs in links
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  });
}

/** Sanitized markdown assigned to an element, for streaming updates. */
export function setMarkdown(element, text) {
  element.innerHTML = renderMarkdown(text);
}
